import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = '/catalogos/catalogo-de-modalidad-de-seguridad-social/';
/**
 * GET UMAS Generales
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getCatalogosDeModalidadDeSeguridadSocial = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET TipoDeSeguridadSocial
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getCatalogoDeModalidadDeSeguridadSocial = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST TipoDeSeguridadSocial
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postCatalogoDeModalidadDeSeguridadSocial = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH TipoDeSeguridadSocial
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchCatalogoDeModalidadDeSeguridadSocial = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
